module.exports = __webpack_public_path__ + "assets/images/extra-04.b37c96522bcfca6dc7e697107c5b7a98.svg";